export class PositionDescription {
  id: number;
  version: number;
  active: boolean;
  certificationRequiredId?: number;
  certificationRequiredDetail: string;
  degreeRequiredId?: number;
  degreeRequiredDetail: string;
  highPointSalary: number;
  lowPointSalary: number;
  midPointSalary: number;
  orgId: number;
  positionDuties: string;
  positionGradeId: number;
  positionGradeDescription: string;
  positionTitle: string;
  qualification: string;
  yearsRequired: number;
}